export default {
  ar() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: 'Room {number}',
      sectionTitle: 'Hotel Details',
    }
  },
  de() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: 'Zimmer {number}:',
      sectionTitle: 'Hotelinformationen',
    }
  },
  en() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: 'Room {number}:',
      sectionTitle: 'Hotel Details',
    }
  },
  enGB() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: 'Room {number}:',
      sectionTitle: 'Hotel Details',
    }
  },
  esMX() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: 'Habitación {number}:',
      sectionTitle: 'Detalles del Hotel',
    }
  },
  fr() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: 'Chambre {number}:',
      sectionTitle: 'Informations sur l\'hôtel',
    }
  },
  it() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: 'Camera {number}:',
      sectionTitle: 'Dettagli alberghieri',
    }
  },
  ja() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: '部屋 {number}:',
      sectionTitle: 'ホテル詳細',
    }
  },
  pl() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: 'pokój {number}:',
      sectionTitle: 'szczegóły dotyczące hotelu',
    }
  },
  zhCN() {
    return {
      description: 'To finalize your hotel stay, please provide the information below.',
      room: '房间 {number}：',
      sectionTitle: '酒店详情'
    }
  }
}
